import React from 'react';
import './footer.css';

import {
  Grid,
  Row,
  Col
} from 'react-bootstrap/lib';

class Footer extends React.Component {
  phoneNumber = '1234556'
  render() {
    return (
      <Row className="footer">
        <Grid>
          <Row>
            <Col xs={12} sm={6} md={3}>
              <div className="table-like full-height">
                <div className="table-cell icon-wrapper">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="table-cell full-height">
                  <a rel="noopener noreferrer" href="https://www.google.co.uk/maps/place/Hardstrasse+24,+8424+Embrach,+Switzerland/@47.5222722,8.584388,17z/data=!3m1!4b1!4m5!3m4!1s0x479076001716f01f:0xb805587d9335fdbf!8m2!3d47.5222722!4d8.586582" target="_blank">
                  Coinreg<br />
                  Hardstrasse 24<br />
                  8424 Embrach
                  </a>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6} md={3}>
              <div className="table-like half-height">
                <div className="table-cell icon-wrapper">
                  <i className="fas fa-phone"></i>
                </div>
                <div className="table-cell clear-fix">
                  <a href="tel:+41786678628">+41 78 667 86 28</a>
                </div>
              </div>
              <div className="table-like half-height">
                <div className="table-cell icon-wrapper">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="table-cell">
                  <a href="mailto:info@virtualcoinreg.com">info@virtualcoinreg.com</a>
                </div>

              </div>
            </Col>
            <Col xs={12} sm={6} md={3}>
              <div className="table-like full-height" style={{width: '100%'}}>
                <div className="table-cell sm-text-center xs-text-left">
                  COMMUNICATION<br /><br />
                  News <br />
                  Facebook<br />
                  Twitter<br />
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6} md={3}>
              <div className="table-like full-height" style={{width: '100%'}}>
                <div className="table-cell sm-text-center xs-text-left">
              LEGAL<br /><br />
              General Terms and Conditions<br />
              Disclaimer and data protection<br />
              Data protection<br />
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </Row>
    );
  }
}
export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js